import { RedesignAuthPage } from 'root/src/client/v2/_pages/auth/redesign/RedesignAuthPage';
import { RETURNING_USER_HIGHLIGHTS } from 'root/src/client/v2/_pages/auth/redesign/authPageHighlights';
import { useAuthPageMode } from 'root/src/client/v2/_pages/auth/redesign/useAuthPageMode';
// Redesign of the legacy `/sign-in` page (LOGIN_FORM_MODULE_ID), served in place at that URL.
// Owns the forgot-password panel too: resetting is a step of signing in, and `/forgot-password`
// stays available for the links that point straight at it.
export const RedesignSignInPage = () => {
    const { mode, onModeChange } = useAuthPageMode({ initialMode: 'signin', ownedModes: ['signin', 'forgot'] });
    return (<RedesignAuthPage mode={mode} onModeChange={onModeChange} headline="Welcome back to Dare Drop" subheadline="Sign in to keep playing dares, claiming rewards and running your campaigns." highlights={RETURNING_USER_HIGHLIGHTS}/>);
};
